import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './ProductCard.module.css.mjs';
import { AccountCardInformation } from './subcomponents/AccountCardInformation/AccountCardInformation.mjs';
import { ProductCardImage } from './subcomponents/ProductCardImage/ProductCardImage.mjs';
import { ProductCardInformation } from './subcomponents/ProductCardInformation/ProductCardInformation.mjs';
import { ProductListSliderInformation } from './subcomponents/ProductListSliderInformation/ProductListSliderInformation.mjs';
import { ShopTheRoomInformation } from './subcomponents/ShopTheRoomInformation/ShopTheRoomInformation.mjs';

const ProductCard = polymorphicFactory(
  (props, ref) => {
    const {
      component = "div",
      image,
      isSaved,
      onSave,
      onShare,
      saveCTA,
      shareCTA,
      sharePopover,
      quickViewCTA,
      title,
      description,
      price,
      slashedPrice,
      type,
      href,
      productDetails,
      className,
      ...rest
    } = props;
    const isProductCard = type === "Product Card";
    const isAccountCard = type === "Account Card";
    const isProductListSlider = type === "Product List Slider";
    const isShopTheRoom = type === "Shop The Room";
    const hasLink = !!(href && isProductCard);
    const showProductInformation = productDetails || title || description || price || slashedPrice;
    if (onSave) console.warn("Property `onSave` will be deprecated soon. Please use `saveCTA` instead.");
    if (onShare) console.warn("Property `onShare` will be deprecated soon. Please use `shareCTA` instead.");
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Box,
      {
        ref,
        className: clsx("kohler-product-card-root", className, classes.productCardContainer),
        component: hasLink ? "div" : component,
        href: !hasLink ? href : void 0,
        ...rest
      },
      /* @__PURE__ */ React.createElement(
        ProductCardImage,
        {
          hasLink,
          href,
          image,
          onSave,
          isSaved,
          onShare,
          saveCTA,
          shareCTA,
          sharePopover,
          quickViewCTA
        }
      ),
      showProductInformation && /* @__PURE__ */ React.createElement(React.Fragment, null, isProductCard && /* @__PURE__ */ React.createElement(
        ProductCardInformation,
        {
          title,
          description,
          price,
          slashedPrice,
          tags: productDetails?.tags,
          bundleItems: productDetails?.bundleItems,
          SKU: productDetails?.SKU,
          taxesLabel: productDetails?.taxesLabel,
          colorSwatches: productDetails?.colorSwatches,
          outOfStockLabel: productDetails?.outOfStockLabel,
          additionalLink: productDetails?.additionalLink,
          checkbox: productDetails?.checkbox
        }
      ), isProductListSlider && /* @__PURE__ */ React.createElement(
        ProductListSliderInformation,
        {
          title,
          description,
          price,
          slashedPrice,
          availableColors: productDetails?.availableColors
        }
      ), isShopTheRoom && /* @__PURE__ */ React.createElement(
        ShopTheRoomInformation,
        {
          title,
          description,
          price,
          slashedPrice,
          brand: productDetails?.brand
        }
      ), isAccountCard && /* @__PURE__ */ React.createElement(
        AccountCardInformation,
        {
          title,
          description,
          price,
          slashedPrice,
          availableColors: productDetails?.availableColors,
          brand: productDetails?.brand
        }
      ))
    ));
  }
);

export { ProductCard };
